import './Desktop.css';
import Minesweeper from './Minesweeper.jsx';

const Desktop =  () => (
    <div className="desktop">
        <Minesweeper />
    </div>
);

export default Desktop;